import PropTypes from 'prop-types';
import { Icon } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';

import {
  Book, BookOpen, EventNote, MoneyOutline,
} from '@openedx/paragon/icons';
import messages from './CatalogCourseModalBanner.messages';
import {
  AVAILABILITY_STATUS,
  availabilitySubtitle,
  checkAvailability,
  checkSubscriptions,
} from '../../utils/catalogUtils';

const AVAILABILITY_MESSAGE_KEYS = {
  [AVAILABILITY_STATUS.AVAILABLE_NOW]: 'CatalogCourseModalBanner.availableNow',
  [AVAILABILITY_STATUS.STARTING_SOON]: 'CatalogCourseModalBanner.startingSoon',
};

const CatalogCourseModalBanner = ({
  coursePrice,
  courseAssociatedCatalogs,
  startDate,
  endDate,
  upcomingRuns,
  execEd,
}) => {
  const intl = useIntl();
  const availabilityStatus = checkAvailability(startDate, endDate);
  const availabilityMessageKey = AVAILABILITY_MESSAGE_KEYS[availabilityStatus];
  const availabilityLabel = availabilityMessageKey ? intl.formatMessage(messages[availabilityMessageKey]) : '';

  return (
    <div className="banner my-3">
      <div className="banner-section mx-3">
        <div className="banner h4 mb-0">
          <Icon className="mr-1" src={MoneyOutline} />
          {coursePrice.split('.')[0]}
        </div>
        <div className="banner-subtitle small">
          {intl.formatMessage(
            messages['CatalogCourseModalBanner.bannerPriceText'],
          )}
        </div>
      </div>
      <div className="banner-section slash">/</div>
      {checkSubscriptions(courseAssociatedCatalogs) && !execEd && (
      <>
        <div className="banner-section mx-3">
          <div className="banner h4 mb-0">
            <Icon className="mr-1" src={BookOpen} />
            {intl.formatMessage(
              messages['CatalogCourseModalBanner.bannerCatalogText'],
            )}
          </div>
          <div className="banner-subtitle small">
            {checkSubscriptions(courseAssociatedCatalogs)}
          </div>
        </div>
        <div className="banner-section slash">/</div>
      </>
      )}
      {execEd && (
      <>
        <div className="banner-section mx-3">
          <div className="banner h4 mb-0">
            <Icon className="mr-1" src={Book} />
            {intl.formatMessage(
              messages['CatalogCourseModalBanner.bannerExecEdText'],
            )}
          </div>
          <div className="banner-subtitle small">
            {intl.formatMessage(
              messages['CatalogCourseModalBanner.bannerExecEdSubtext'],
            )}
          </div>
        </div>
        <div className="banner-section slash">/</div>
      </>
      )}
      <div className="banner-section mx-3">
        <div className="banner h4 mb-0">
          <Icon className="mr-1" src={EventNote} />
          {availabilityLabel}
        </div>
        <div className="banner-subtitle small">
          {availabilitySubtitle(startDate, endDate, upcomingRuns)}{' '}
        </div>
      </div>
    </div>
  );
};

CatalogCourseModalBanner.defaultProps = {
  coursePrice: '0',
  courseAssociatedCatalogs: [],
  startDate: '',
  endDate: '',
  upcomingRuns: 0,
  execEd: false,
};

CatalogCourseModalBanner.propTypes = {
  coursePrice: PropTypes.string,
  courseAssociatedCatalogs: PropTypes.arrayOf(PropTypes.string),
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  upcomingRuns: PropTypes.number,
  execEd: PropTypes.bool,
};

export default CatalogCourseModalBanner;
